import filterIds from './filter_ids';


export default class RequestFilterBuilder {

    constructor() {
        this.selectedFilters = {
            [filterIds.DATE]: [],
            [filterIds.STATUS]: [],
            [filterIds.ACCOUNT_MANAGER]: [],
            [filterIds.VENDOR]: [],
            [filterIds.PRICE]: [],
            [filterIds.BUDGET]: '',
            [filterIds.IS_PBD]: [],
            [filterIds.DEAL_STATUS]: []
        };
    }

    addParam(filterId, itemId) {
        const filterValues = this.selectedFilters[filterId];
        if(!filterValues.includes(itemId)) {
            filterValues.push(itemId);
        }
    }

    addBudgetParam(itemId) {
        this.selectedFilters[filterIds.BUDGET] = itemId;
    }
    addStatusParam(itemId) {
        this.addParam(filterIds.STATUS, itemId);
    }
    addDealStatusParam(itemId) {
        this.addParam(filterIds.DEAL_STATUS, itemId);
    }

    addDateParam(itemId) {
        this.addParam(filterIds.DATE, itemId);
    }

    removeParam(filterId, itemId) {
        const filterValues = this.selectedFilters[filterId];
        if(filterValues.includes(itemId)) {
            const newValues = filterValues.filter(value => {
                return value !== itemId;
            });

            this.selectedFilters[filterId] = newValues;
        }
    }

    getMonthRanges(monthsWithYear){
        const result = [];

        monthsWithYear.forEach(monthWithYear => {

            //If the date contains a slash, it means it's a full date range and not a month.
            if(monthWithYear.indexOf('/') >= 0) {
                result.push(monthWithYear);
                return;
            }

            const year = parseInt(monthWithYear.split('-')[0]);
            const month = parseInt(monthWithYear.split('-')[1]);

            // the following code calculates the last day of the month.
            const tempDate = new Date(year, month + 1, 0);
            const lastDay = tempDate.getDate();

            // JavaScript handles months from 0 to 11. However, our backend expectes months from 1 to 12.
            // That's why I add 1.
            const startDate = `${month + 1}/1/${year}`;
            const endDate = `${month + 1}/${lastDay}/${year}`;
            result.push(`${startDate}-${endDate}`);

        });

        return result;

    }

    getDataQueryString(filter, items, tokens){
        if(items.length > 0){
            if(Array.isArray(items)){
                tokens.push(filter + '=' + items.join());
            }else{
                tokens.push(filter + '=' + items);
            }    
        }
    }

    getQueryString() {
        const tokens = [];
        for(const filter in this.selectedFilters) {
            const items = this.selectedFilters[filter];
            //when the "all" option is selected, we don't need to include the param.
            if(items.includes('all')) continue;
            
            if(filter === filterIds.DATE){
                // We need to get the month start and end date
                const ranges = this.getMonthRanges(items);
                this.getDataQueryString(filter, ranges, tokens);
            }
            else if(filter === filterIds.IS_PBD){
                if(items.length > 1) continue;
                const item = items.length === 0 ? [] : [items[0] === 'pbd'];
                this.getDataQueryString(filter, item, tokens);
            }else{
                this.getDataQueryString(filter, items, tokens);
            }
        }
        let result = tokens.join('&');
        return result;
    }

}